export default __webpack_public_path__ + "static/media/logo.ecd4d71a.png";